<template>
    <div
        v-if="config.title"
        class="pb-2 px-4 pt-10 first:pt-5 content-sm-ux-medium text-neutral-extra-strong"
    >
        {{ config.title }}
    </div>
    <div class="flex items-center gap-x-3 px-4 py-4">
        <template
            v-for="(item, index) in config.links"
            :key="index"
        >
            <!-- Social links require an icon to be shown -->
            <div
                v-if="item.icon"
                class="flex items-center justify-center w-12 h-12 surface-secondary rounded-card-sm shape-brand-base cursor-pointer transition-colors"
                @click="onClick(item)"
            >
                <UIIcon
                    :icon="item.icon"
                    weight="regular"
                    :size="24"
                />
            </div>
        </template>
    </div>
</template>

<script setup>
    import { useRouter } from 'vue-router'

    import UIIcon from '@/components/ui/UIIcon.vue'

    const props = defineProps({
        config: Object,
    })

    const router = useRouter()
    const moduleHelpers = useModuleHelpers()

    const clicking = ref(false)

    const onClick = (item) => {
        if (clicking.value) {
            return
        }

        clicking.value = true
        moduleHelpers.openModuleOrOpenBrowserForLinkData(router, item.link)
            .catch((e) => {
                console.log('Failed to open link', e)
            })
            .finally(() => {
                clicking.value = false
            })
    }
</script>
